<template>
    <DashboardContainer>
        <RawLeads/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import RawLeads from '../components/leads/RawLeads'

export default {
    name: 'Rawleads',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        RawLeads
    }
}
</script>